import { render, staticRenderFns } from "./CustomerDisplay.vue?vue&type=template&id=fc0cb046&scoped=true&"
import script from "./CustomerDisplay.vue?vue&type=script&lang=js&"
export * from "./CustomerDisplay.vue?vue&type=script&lang=js&"
import style0 from "../styles/customer-display.css?vue&type=style&index=0&id=fc0cb046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0cb046",
  null
  
)

export default component.exports